/**
 * Dentis Promo Status block hydration.
 *
 * Listens for `dentis:discount-resolved` and:
 *   - If a code is active and the current product is eligible (or block is set
 *     to render even when ineligible), reveals the block, replaces placeholders
 *     `{code}`, `{savings_percent}`, `{savings_amount}`, `{shipping_benefit}`.
 *   - Otherwise, leaves the block hidden.
 */
(function () {
  'use strict';

  var EVENT_NAME = 'dentis:discount-resolved';
  var DBG = (window.DentisDebug || { enabled: false, log: function () {}, warn: function () {}, error: function () {} });

  function withThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var amount = Number(cents) / 100;
    if (Math.abs(amount - Math.round(amount)) < 0.005) {
      return withThousands(String(Math.round(amount)), ' ') + ' kr';
    }
    return withThousands(String(Math.floor(amount)), ' ') + ',' + (amount.toFixed(2).split('.')[1]) + ' kr';
  }

  function getProductEligibility(resolved, productId) {
    if (!resolved || !resolved.active) return null;
    if (resolved.type !== 'percentage' && resolved.type !== 'fixed') return null;
    var bucket = resolved.eligible && resolved.eligible[String(productId || '')];
    if (bucket) {
      var perVariant = 0;
      for (var k in bucket.variants) {
        if (Number(bucket.variants[k]) > perVariant) perVariant = Number(bucket.variants[k]);
      }
      return {
        total: Number(bucket.savings_total || 0),
        perVariant: perVariant
      };
    }
    // Heuristic: target_selection === 'all' codes apply to every product.
    if (resolved.target_selection === 'all' && (resolved.target_type === 'line_item' || !resolved.target_type)) {
      return { total: 0, perVariant: 0, fromAllSelector: true };
    }
    return null;
  }

  function fillTemplate(template, resolved, perVariantSavingsCents) {
    if (!template) return '';
    var code = (resolved && resolved.code) || '';
    var pct = '';
    var amt = '';
    var shipping = '';

    if (resolved && resolved.type === 'percentage') {
      pct = String(Math.round(Number(resolved.value || 0)));
    } else if (resolved && resolved.type === 'fixed' && perVariantSavingsCents) {
      // Best-effort percent for fixed-amount codes when we can compute it
      // (otherwise leave blank - merchants should not use {savings_percent} for fixed codes).
    }
    if (perVariantSavingsCents) {
      amt = formatMoney(perVariantSavingsCents);
    }
    if (resolved && resolved.type === 'shipping') {
      shipping = 'gratis frakt';
    }

    return template
      .replace(/\{code\}/g, code)
      .replace(/\{savings_percent\}/g, pct)
      .replace(/\{savings_amount\}/g, amt)
      .replace(/\{shipping_benefit\}/g, shipping);
  }

  function processBlock(block, resolved) {
    var productId = block.getAttribute('data-dentis-product-id');
    var textTarget = block.querySelector('[data-dentis-promo-text]');
    DBG.log('processBlock', { block: block, productId: productId, hasTextTarget: !!textTarget, resolved: resolved });
    if (!textTarget) {
      DBG.warn('promo block has no [data-dentis-promo-text] child; skipping');
      return;
    }

    if (!resolved || !resolved.active) {
      DBG.log('no active discount; hiding promo block');
      block.setAttribute('hidden', '');
      return;
    }

    if (resolved.type === 'shipping') {
      // Shipping codes apply to the order — show the block with shipping text.
      var shippingTpl = block.getAttribute('data-dentis-template');
      textTarget.textContent = fillTemplate(shippingTpl, resolved, 0);
      block.removeAttribute('hidden');
      return;
    }

    if (resolved.type !== 'percentage' && resolved.type !== 'fixed') {
      // BXGY etc. — show static "code active" status using the default template
      var btpl = block.getAttribute('data-dentis-template');
      textTarget.textContent = fillTemplate(btpl, resolved, 0);
      block.removeAttribute('hidden');
      return;
    }

    var elig = getProductEligibility(resolved, productId);
    var suppressWhenIneligible = block.getAttribute('data-dentis-suppress-when-ineligible') === '1';
    if (!elig) {
      if (suppressWhenIneligible) {
        block.setAttribute('hidden', '');
        return;
      }
      // Render generic active text without product-specific savings
      var generic = block.getAttribute('data-dentis-template');
      textTarget.textContent = fillTemplate(generic, resolved, 0);
      block.removeAttribute('hidden');
      return;
    }

    var tpl = block.getAttribute('data-dentis-template');
    textTarget.textContent = fillTemplate(tpl, resolved, elig.perVariant);
    block.removeAttribute('hidden');
  }

  function processAll(resolved) {
    var blocks = document.querySelectorAll('[data-dentis-promo-status]');
    DBG.log('processAll: found ' + blocks.length + ' [data-dentis-promo-status] blocks');
    for (var i = 0; i < blocks.length; i++) processBlock(blocks[i], resolved);
  }

  function handle(resolved) {
    try { processAll(resolved); } catch (e) { DBG.error('handle() threw', e); }
  }

  document.addEventListener(EVENT_NAME, function (ev) {
    handle((ev && ev.detail) || window.DentisActiveDiscount);
  });

  function maybeReplay() {
    if (window.DentisActiveDiscount) {
      DBG.log('replay: window.DentisActiveDiscount already set on listener attach', window.DentisActiveDiscount);
      handle(window.DentisActiveDiscount);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeReplay);
  } else {
    setTimeout(maybeReplay, 0);
  }
})();
